// extracted by mini-css-extract-plugin
export default {"errorBoundary":"AppErrorBoundary_errorBoundary__MxOZo"};